import { get } from './index';

// Raw response (no camelizeKeys): the payload shows the request body as sent.
export const getAuditLogs = query =>
  get(`/api/internal/audit-logs?${query}`, {}, false).then(({ data }) => data);

// type: bookings, organizations, users, hotels, trips or folders.
export const getResourceAuditLogs = (type, id, query) =>
  get(
    `/api/internal/audit-logs/resources/${type}/${id}?${query}`,
    {},
    false,
  ).then(({ data }) => data);
